module.exports = {
  pagination: {initPage: 1, pageSize: 50},
  postingSellProperty: 0,
};
